import { common } from './common';
import { homeEvents } from './home';

export const events = { common, homeEvents };
